module.exports = __webpack_public_path__ + "static/Andrea-Gallidabino-4b2353d808a4fef1239e1c4bb9b4c781.jpg";